import script from "./AddAssetTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAssetTemplate.vue?vue&type=script&setup=true&lang=js"

import "./AddAssetTemplate.vue?vue&type=style&index=0&id=578a0978&lang=scss&scoped=true"
import "./AddAssetTemplate.vue?vue&type=style&index=1&id=578a0978&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-578a0978"]])

export default __exports__